import styled from 'styled-components';

import { Theme } from '../Theme';

export const RootContainer = styled.div`
	margin: 0rem 0rem;
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const Container = styled.div`
	margin: 1rem 0rem 1rem 0rem;
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: auto;
	scrollbar-width: thin;
	scrollbar-color: ${Theme.scrollThumb} ${Theme.scrollBar};
	&::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}
	&::-webkit-scrollbar-track {
		background: ${Theme.scrollBar};
	}
	&::-webkit-scrollbar-thumb {
		background: ${Theme.scrollThumb};
		border-radius: 8px;
	}
	&::-webkit-scrollbar-thumb:hover {
		background: ${Theme.scrollThumb};
	}
`;
